import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  estateTaskRowLabelCompleted: {
    lineHeight: '1.43',
    color: '#1C2541',
  },
  estateTaskRowLabelNotCompleted: {
    lineHeight: '1.43',
    color: '#434E59',
  },
  estateTaskRowNoLabelHint: {
    height: 0,
    visibility: 'hidden',
  },
  estateTaskRowLabelHint: {
    lineHeight: '1.43',
    fontSize: '.75rem',
    color: '#999',
  },
  warningText: {
    color: 'red',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
    marginTop: '6px',
  },
}));
